var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-icon',{attrs:{"x-large":""}},[_vm._v("mdi "+_vm._s(_vm.icon))])
}
var staticRenderFns = []

export { render, staticRenderFns }